import React, { useState } from 'react';
import { styled, useMediaQuery, useTheme } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { Colors } from 'library';
import { DropdownMenu, IconButton, PillButton, Row } from 'library/ui';
import MenuIcon from '@mui/icons-material/Menu';
import NavyLogo from 'assets/images/NavyLogo.svg';
import useTrackingCookies from 'parent-portal/shared/EngagementSourceTracking';

export default function PublicNavBar({ hideCenterLogin = false }: { hideCenterLogin?: boolean }) {
    useTrackingCookies('/');
    const theme = useTheme();
    const isCompact = useMediaQuery(theme.breakpoints.down('md'));
    const [menuOpen, setMenuOpen] = useState(false);

    return (
        <Bar>
            <Row justify="between" align="center" fullWidth>
                <LogoLink to="/">
                    <NavyLogo height={50} width={150} alt="tandem logo" />
                </LogoLink>
                {!hideCenterLogin &&
                    (isCompact ? (
                        <DropdownMenu
                            open={menuOpen}
                            onClose={() => setMenuOpen(false)}
                            items={[
                                { label: 'Sign Up', to: '/signup' },
                                { label: 'Center Login', to: '/login' },
                            ]}
                            trigger={<IconButton icon={MenuIcon} onClick={() => setMenuOpen((prev) => !prev)} />}
                        />
                    ) : (
                        <PillButton id="center-login-link" to="/login">
                            Center Login
                        </PillButton>
                    ))}
            </Row>
        </Bar>
    );
}

const Bar = styled('header')({
    position: 'relative',
    zIndex: 1,
    backgroundColor: Colors.white,
    boxShadow: '0 1px 6px rgb(0 0 0 / 15%)',
    padding: '6px 16px',
});

const LogoLink = styled(RouterLink)({
    display: 'flex',
    alignItems: 'center',
    paddingLeft: 10,
});
